/* ==========================================================================
   BD Quick View + Add To Cart
   File: assets/bd-quick-view.js

   Handles:
   - .bd-quickview-btn clicks  -> fetch product JSON, open modal, let user pick size
   - .bd-pcard-atc-btn clicks  -> since every product has multiple sizes, this also
     opens the same modal (size must be chosen before adding to cart)
   - Add to cart from inside the modal -> POST to /cart/add.js
   ========================================================================== */

(function () {
  'use strict';

  var modal = document.getElementById('bd-qv-modal');
  var overlay = document.getElementById('bd-qv-overlay');
  var closeBtn = document.getElementById('bd-qv-close');
  var body = document.getElementById('bd-qv-body');

  if (!modal) return;

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (format) return format.replace('{{amount}}', value);
    return '₹' + value;
  }

  function renderProduct(product) {
    var variants = product.variants || [];
    var firstAvailable = variants.filter(function (v) { return v.available; })[0] || variants[0];
    var image = (product.featured_image || (product.images && product.images[0])) || '';
    if (image && image.indexOf('http') !== 0) image = 'https:' + image;

    var compareAt = firstAvailable ? firstAvailable.compare_at_price : null;
    var price = firstAvailable ? firstAvailable.price : product.price;

    var priceHtml = '<span>' + money(price) + '</span>';
    if (compareAt && compareAt > price) {
      priceHtml = '<span class="bd-price-sale">' + money(price) + '</span>' +
                  '<span class="bd-price-compare">' + money(compareAt) + '</span>';
    }

    var sizeButtons = variants.map(function (v) {
      var cls = 'bd-qv-size-btn' +
        (v.id === (firstAvailable && firstAvailable.id) ? ' is-selected' : '') +
        (!v.available ? ' is-unavailable' : '');
      return '<button type="button" class="' + cls + '" data-variant-id="' + v.id + '" data-available="' + v.available + '">' + v.title + '</button>';
    }).join('');

    body.innerHTML =
      '<div class="bd-qv-grid">' +
        '<div class="bd-qv-image-wrap"><img src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '"></div>' +
        '<div class="bd-qv-details">' +
          '<h2 class="bd-qv-title">' + product.title + '</h2>' +
          '<div class="bd-qv-price">' + priceHtml + '</div>' +
          '<p class="bd-qv-option-label">Select Size</p>' +
          '<div class="bd-qv-size-list">' + sizeButtons + '</div>' +
          '<button type="button" class="bd-qv-atc-btn" id="bd-qv-atc-btn" data-variant-id="' + (firstAvailable ? firstAvailable.id : '') + '" ' + (firstAvailable ? '' : 'disabled') + '>' +
            (firstAvailable ? 'Add To Cart' : 'Sold Out') +
          '</button>' +
          '<a href="/products/' + product.handle + '" class="bd-qv-view-full">View Full Details</a>' +
        '</div>' +
      '</div>';

    var sizeBtns = body.querySelectorAll('.bd-qv-size-btn');
    var atcBtn = document.getElementById('bd-qv-atc-btn');

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        sizeBtns.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        atcBtn.dataset.variantId = btn.dataset.variantId;
        atcBtn.disabled = false;
        atcBtn.textContent = 'Add To Cart';
        atcBtn.classList.remove('is-added');
      });
    });

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        addToCart(atcBtn.dataset.variantId, atcBtn);
      });
    }
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.textContent = 'Added!';
        btn.classList.add('is-added');
        // Redirect straight to the cart page — this also solves the
        // "header cart count doesn't update" issue, since navigating
        // to a new page always renders the header fresh with the
        // correct count (no separate AJAX badge-sync needed).
        window.location.href = '/cart';
      })
      .catch(function () {
        btn.textContent = 'Something went wrong';
        btn.disabled = false;
      });
  }

  function loadProduct(handle) {
    body.innerHTML = '<div class="bd-qv-loading" id="bd-qv-loading">Loading&hellip;</div>';
    openModal();

    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) { renderProduct(product); })
      .catch(function () {
        body.innerHTML = '<div class="bd-qv-loading">Could not load this product. Please try again.</div>';
      });
  }

  // Delegated click handling — works for cards rendered anywhere, including dynamically
  document.addEventListener('click', function (e) {
    var qvBtn = e.target.closest('.bd-quickview-btn');
    var atcBtn = e.target.closest('.bd-pcard-atc-btn');

    if (qvBtn) {
      e.preventDefault();
      loadProduct(qvBtn.dataset.productHandle);
      return;
    }

    if (atcBtn && !atcBtn.disabled) {
      e.preventDefault();
      loadProduct(atcBtn.dataset.productHandle);
    }
  });

  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  if (overlay) overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();